import { forwardRef } from 'react';
import { SvgIconProps } from 'src/types';

export const CheckCircleIcon = forwardRef<SVGSVGElement, SvgIconProps>(
  (props, ref) => {
    return (
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={ref}
        {...props}
      >
        <path
          d="M15.2075 6.94831L9.16665 12.9891L5.87581 9.70748L4.58331 11L9.16665 15.5833L16.5 8.24998L15.2075 6.94831ZM11 1.83331C5.93998 1.83331 1.83331 5.93998 1.83331 11C1.83331 16.06 5.93998 20.1666 11 20.1666C16.06 20.1666 20.1666 16.06 20.1666 11C20.1666 5.93998 16.06 1.83331 11 1.83331ZM11 18.3333C6.94831 18.3333 3.66665 15.0516 3.66665 11C3.66665 6.94831 6.94831 3.66665 11 3.66665C15.0516 3.66665 18.3333 6.94831 18.3333 11C18.3333 15.0516 15.0516 18.3333 11 18.3333Z"
          fill="#3DB157"
        />
      </svg>
    );
  },
);

CheckCircleIcon.displayName = 'CheckCircleIcon';
